(function(){
  async function init_filter(first_init = false){
    await MB_sleep(100)
    if(first_init){
    }
    await MB_waitElementReady('.t4s-collection-header form:not(.inited)')
    await MB_waitElementReady('.t4s-filter-hidden form:not(.inited)')
    console.log('init_filter','mibao')
    $('.t4s-collection-header .filter_list h4, .t4s-filter-hidden .filter_list h4').off("click").on("click", function(e){
      $parent = $(this).parent()
      $parent.toggleClass('is_opened')
    })
    $('.t4s-collection-header .t4s-filter-area .t4s-facet-title, .t4s-filter-hidden .t4s-facet-title').off("click").on("click", function(e){
      $parent = $(this).parent()
      $parent.toggleClass('is_opened')
    })
    $('.t4s-collection-header .t4s-filter-area #blockid_1').first().addClass('is_opened')
    $('.t4s-filter-hidden #blockid_1').first().addClass('is_opened')

    if (location.search) { 
      const url = window.location.href
      // 使用正则获取url所有参数名称和值，构成一个对象。
      // 相同参数名可能会有多个值，多值用数组保存
      const params = url.match(/([^?=&]+)(=([^&]*))/g).reduce((acc, cur) => {
        const [key, value] = cur.split('=')
        if (acc[key]) {
          if (!Array.isArray(acc[key])) {
            acc[key] = [acc[key]]
          }
          acc[key].push(value)
        } else {
          acc[key] = value
        }
        return acc; // 这一行是关键，必须返回累加器
      }, {}) // 同时需要提供初始值 {}
      // console.log(params, Object.keys(params))

      const keys = Object.keys(params)
      console.log(keys,'mibao')
      $('.t4s-collection-header .t4s-filter-area .t4s-col-item, .t4s-filter-hidden .t4s-col-item').each(function(index){
        const param_name = $(this).data('param_name').replace(/-/g, '.')
        let is_opened = false
        if(keys.includes(param_name)){
          is_opened = true
        }else if(param_name == 'filter.v.price' && (keys.includes('filter.v.price.gte') || keys.includes('filter.v.price.lte'))){
          is_opened = true
        }
        // console.log(param_name, is_opened, 'mibao')
        console.log($(this), is_opened, 'mibao')
        if(is_opened){
          $(this).addClass('is_opened')
        }
      })
    }
    $('.t4s-collection-header form, .t4s-filter-hidden form').addClass('inited')
    
    // await MB_waitElementReady('.t4s-filter-hidden .sortby_list_items .sortby_item input')
    // $('.t4s-filter-hidden .sortby_list_items .sortby_item label').off("click").on("click", async function(e){
    //   await MB_sleep(100)
    //   T4SThemeSP.Drawer.close()
    //   console.log(e)
    // })
    // $('.t4s-filter-hidden').addClass('inited')
    
  }
  async function bottom_into_button_more(){
    console.log('bottom_into_button_more','mibao')
    const element = '.collection-footer-info .read_more'
    await MB_waitElementReady(element)
    $('.collection-footer-info .read_more').click(function(e){
      e.preventDefault()
      $('.collection-footer-info').addClass('is_opened')
    })
    $('.collection-footer-info .read_less').click(function(e){
      e.preventDefault()
      $('.collection-footer-info').removeClass('is_opened')
    })
  }
  async function init_comparer(){
    await MB_waitElementReady('.popular_ice_maker_comparisons .flickityt4s-slider')
    const flickity_el = $(".popular_ice_maker_comparisons .t4s-flicky-slider")[0]
    const carousel = flickity_el.flickityt4s.$carousel
    const flkty = flickity_el.flickityt4s.flkty

    $('.popular_ice_maker_comparisons .product_type_select a').click(function(e){ 
      e.preventDefault();
      const handle = $(this).data('product-type')
      init_comparer_slider(handle)
    })
    function init_comparer_slider(handle){ 
      $('.popular_ice_maker_comparisons .product_type_select a').removeClass('is_select')
      $(`.popular_ice_maker_comparisons .product_type_select a[data-product-type=${handle}`).addClass('is_select')

      $('.popular_ice_maker_comparisons .flickityt4s-slider .t4s-product').each(function(index){
        const product_handle = $(this).data('product-type')
        if(product_handle == handle){
          $(this).show()
        }else{
          $(this).hide()
        }
      })
      flickity_el.flickityt4s.flkty.resize()
    }
    const init_handle = $('.popular_ice_maker_comparisons .product_type_select a').first().data('product-type')
    init_comparer_slider(init_handle)
  }
  async function init_faq(){
    await MB_waitElementReady('.mibao-faq li .content')
    const total = $('.mibao-faq ul li').length
    if(total > 4){
      $('.mibao-faq').addClass('has_more')
    }

    $('.mibao-faq .t4s-viewall-btn').click(function(e){
      e.preventDefault();
      $('.mibao-faq').addClass('is_opened')
    })
    $('.mibao-faq .t4s-viewless-btn').click(function(e){
      e.preventDefault();
      $('.mibao-faq').removeClass('is_opened')
    })
  }
  async function init(){
    init_filter()
    init_comparer()
    init_faq()
    bottom_into_button_more()
    $(window).on('facets:loadPageContented', async function(e){
      console.log('facets:loadPageContented')
      T4SThemeSP.Drawer.close()
      init_filter()
    })
    $(window).on('facets:updateURLHash', function(e){
      console.log('facets:updateURLHash')
    })
  }
  MB_jsDeferHandle(init, ['jQuery'])
  
}) ()